import styled from "styled-components";

export const StyledCheckmarkControl = styled.span`
  align-items: center;
  background: ${(props) =>
    props.selected ? props.primaryColor : "transparent"};
  border: 2px solid
    ${(props) =>
      props.selected ? props.primaryColor : "var(--rms-v2-text-muted)"};
  border-radius: 50%;
  box-sizing: border-box;
  color: var(--rms-v2-surface);
  display: inline-flex;
  flex: 0 0 ${(props) => props.size}px;
  font-size: ${(props) => props.fontSize}px;
  font-weight: 800;
  height: ${(props) => props.size}px;
  justify-content: center;
  width: ${(props) => props.size}px;
`;
